import { createActionGroup, props } from '@ngrx/store';
import { id } from '@wonder-core-ng/interfaces/id.type';
import { IQueryConfigData } from '../query-engine/interfaces/query.interface';

export const QueryConfigActions = createActionGroup({
  source: 'QueryConfig',
  events: {
    // save query config (structured config only — never raw SQL)
    'Save Query Config': props<{ queryConfigData: IQueryConfigData; tenantId: id }>(),
    'Save Query Config Success': props<{ queryConfigData: IQueryConfigData }>(),
    'Save Query Config Failure': props<{ error: unknown }>(),

    // httpResult
    'Http Result': props<{ action: string; error: unknown }>(),
  },
});
